import {
  Cat20Utxo,
  SupportedNetwork,
  Cat721Utxo
} from '@cat-protocol/cat-sdk';
import fetch from 'cross-fetch';

function getTrackerUrl(v1: boolean, network: SupportedNetwork): string {
  const _network = network.replaceAll('fractal-', '').toUpperCase();
  const prefix = v1 ? "TRACKER_V1" : "TRACKER_V2";
  const trackerUrl = process.env[`REACT_APP_${prefix}_${_network}_URL`]
  if (!trackerUrl) throw new Error(`REACT_APP_${prefix}_${_network}_URL should be set in env`);
  return trackerUrl.replace(/\/$/, "");
}


export const getTokens = async function (
  v1: boolean,
  network: SupportedNetwork,
  tokenId: string,
  ownerAddress: string,
): Promise<Array<Cat20Utxo>> {
  const baseApi = getTrackerUrl(v1, network);
  const url = `${baseApi}/api/tokens/${tokenId}/addresses/${ownerAddress}/utxos?limit=10`;
  return fetch(url, {})
    .then((res) => res.json())
    .then((res: any) => {
      if (res.code === 0) {
        return res.data;
      } else {
        throw new Error(res.msg);
      }
    })
    .then(({ utxos }) => {
      let cat20Utxos: Array<Cat20Utxo> = utxos.map((utxoData: any) => {
        if (typeof utxoData.utxo.satoshis === 'string') {
          utxoData.utxo.satoshis = parseInt(utxoData.utxo.satoshis);
        }

        const cat20Utxo: Cat20Utxo = {
          utxo: utxoData.utxo,
          txoStateHashes: utxoData.txoStateHashes,
          state: {
            ownerAddr: utxoData.state.address,
            amount: BigInt(utxoData.state.amount),
          },
        };

        return cat20Utxo;
      });

      return cat20Utxos;
    })
    .catch((e) => {
      return [];
    });
};


export const getNfts = async function (
  v1: boolean,
  network: SupportedNetwork,
  ownerAddress: string,
  collectionId: string,
  offset: number = 0,
  limit: number = 100,
): Promise<Array<Cat721Utxo>> {
  const baseApi = getTrackerUrl(v1, network);
  const url = `${baseApi}/api/collections/${collectionId}/addresses/${ownerAddress}/utxos?offset=${offset}&limit=${limit}`;
  return fetch(url, {})
    .then((res) => res.json())
    .then((res: any) => {
      if (res.code === 0) {
        return res.data;
      } else {
        throw new Error(res.msg);
      }
    })
    .then(({ utxos }) => {

      let cat20Utxos: Array<Cat721Utxo> = utxos.map((utxoData: any) => {
        if (typeof utxoData.utxo.satoshis === 'string') {
          utxoData.utxo.satoshis = parseInt(utxoData.utxo.satoshis);
        }

        const cat721Utxo: Cat721Utxo = {
          utxo: utxoData.utxo,
          txoStateHashes: utxoData.txoStateHashes,
          state: {
            ownerAddr: utxoData.state.address,
            localId: BigInt(utxoData.state.localId),
          },
        };

        return cat721Utxo;
      });

      return cat20Utxos;
    })
    .catch((e) => {
      console.error(`fetch nfts failed:`, e);
      return [];
    });
};


export const getAllNfts = async function (
  v1: boolean,
  network: SupportedNetwork,
  ownerAddress: string,
  collectionId: string,
): Promise<Array<Cat721Utxo>> {
  
  const nftMap = new Map<string, Cat721Utxo>();
  let offset = 0;
  const LIMIT = 500;

  try {
    for (let i = 0; i < 100000; i++) {
      const utxos = await getNfts(v1, network, ownerAddress, collectionId, offset, LIMIT);
  
      for (let i = 0; i < utxos.length; i++) {
        const utxo = utxos[i];
        const key = `${utxo.utxo.txId}:${utxo.utxo.outputIndex}`;
        if (!nftMap.has(key)) {
          nftMap.set(key, utxo);
        }
      }
  
      if(utxos.length === 0 || utxos.length < LIMIT) {
        break;
      }
      offset += LIMIT;
    }
  } catch (error) {
    
  }

  return Array.from(nftMap.values()).sort((a, b) => Number(a.state.localId - b.state.localId));
};
